/* ==========================================================================
   BLOCK — Blog : grille d'articles
   Chargement de la page suivante (bouton et/ou défilement infini).
   Le défilement horizontal des pills de tags est porté par
   `snippets-horizontal-scroller.js`.
   ========================================================================== */
(function () {
  'use strict';

  function initLoadMore(root) {
    var grid = root.querySelector('[data-article-grid]');
    var container = root.querySelector('[data-load-more]');
    if (!grid || !container) return;

    var mode = container.dataset.mode;
    var sectionId = container.dataset.sectionId;
    var btn = container.querySelector('[data-load-more-btn]');
    var spinner = container.querySelector('[data-loading]');
    var observer = null;
    var loading = false;

    function fetchNextPage() {
      var nextUrl = container.dataset.nextUrl;
      if (!nextUrl || loading) return;

      loading = true;
      if (btn) btn.disabled = true;
      if (spinner) spinner.hidden = false;

      var fetchUrl = nextUrl;
      if (sectionId) {
        fetchUrl += (nextUrl.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;
      }

      fetch(fetchUrl)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var blockId = root.dataset.blockId;
          var scope = blockId
            ? doc.querySelector('[data-blog-articles-grid][data-block-id="' + blockId + '"]')
            : null;
          scope = scope || doc;

          var newGrid = scope.querySelector('[data-article-grid]');

          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (child) {
              grid.appendChild(child);
            });
          }

          var newLoadMore = scope.querySelector('[data-load-more]');
          if (newLoadMore && newLoadMore.dataset.nextUrl) {
            container.dataset.nextUrl = newLoadMore.dataset.nextUrl;
          } else {
            container.dataset.nextUrl = '';
            container.hidden = true;
            if (observer) observer.disconnect();
          }
        })
        .catch(function (error) {
          console.error('[blog-articles-grid] Load more failed:', error);
        })
        .then(function () {
          loading = false;
          if (btn) btn.disabled = false;
          if (spinner) spinner.hidden = true;
        });
    }

    if (btn) {
      btn.addEventListener('click', fetchNextPage);
    }

    if (mode === 'auto' || mode === 'both') {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) fetchNextPage();
      }, { rootMargin: '400px' });
      observer.observe(container);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-blog-articles-grid]').forEach(function (root) {
      if (root.dataset.blogGridBound === 'true') return;
      root.dataset.blogGridBound = 'true';

      initLoadMore(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Ré-initialisation après un re-render dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', initAll);
})();
